import {
  IStoryblokColorPicker,
  IStoryBlokComponent,
} from "~interfaces/storyblock";
import React from "react";
import Components from "~components/components";
import { IBulletPointsItem } from "~components/custom/bullet-points/bullet-points-item";
import { Accordion } from "@ef-global/web-ui-react";
import styles from "./bullet-points.module.scss";
import css from "@emotion/css";

interface IBulletPointsSection extends IStoryBlokComponent {
  bullet_points: Array<IBulletPointsItem>;
  border_bottom_separator_color: IStoryblokColorPicker;
  chevron_text_item_color: IStoryblokColorPicker;
  story: any;
  accordion_mobile: boolean;
}

export const BulletPointsSection = (props: IBulletPointsSection) => {
  const {
    bullet_points,
    border_bottom_separator_color,
    chevron_text_item_color,
    story,
  } = props;

  const renderBulletItem = () =>
    bullet_points.map((blok) => Components(blok, story));

  const acordionSectionCss = css`
    ${!!border_bottom_separator_color?.color &&
    `.ef-accordion__item {
      border-bottom-color: ${border_bottom_separator_color?.color} !important;
    }`}
    ${!!chevron_text_item_color?.color &&
    `
    h6, p {
      color: ${chevron_text_item_color?.color} !important;
    }.ef-collapsible__toggle {
      > svg {
        fill: ${chevron_text_item_color?.color} !important;
        path {
          fill: ${chevron_text_item_color?.color} !important;
        }
      }
    }`}
  `;

  return (
    <div css={acordionSectionCss}>
      <Accordion
        className={`u-mb-xl full-width u-show-s-only ${styles.bulletColumn}`}
      >
        {renderBulletItem()}
      </Accordion>
      <div className={`ef-row u-show-m-up`}>{renderBulletItem()}</div>
    </div>
  );
};
